export default "__VITE_ASSET__bVSSoIS0__"